<div class="successfull-request-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="handleModalHide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="info">
      <img src="../../../../assets/success-icon.png" alt="Successful Icon" />
      <h3>Request is created successfully!</h3>
      <h4>SMS has been sent to patient for confirmation.</h4>
      <h5 class="text-center" *ngIf="orderMerchantId !== ''">Merchant Order Id<br> {{ orderMerchantId }}</h5>
    </div>
    <div class="actions">
      <button class="btn view-btn" (click)="handleViewRequest()">
        View Request Details
      </button>
      <button class="btn create-btn" (click)="handleCreateRequest()">
        Create Another Request
      </button>
      <button class="btn btn-link back-btn" (click)="handleBackToRequests()">
        Back to Request History
      </button>
    </div>
  </div>
</div>
